import keyMirror from 'keymirror';

const seatmapSectionCodes = keyMirror({
  AM_PLUS: null,
  COACH: null,
  EXIT_ROW: null,
  FIRST_CLASS: null,
  FIRST_LIGHT_CLASS: null,
  FIRST_ONE_CLASS: null,
  FIRST_ONE_CLASS_787: null,
  FIRST_ONE_CLASS_788: null,
  FIRST_ONE_CLASS_789: null,
  PREFERRED: null,
});

export default seatmapSectionCodes;
